import { app } from '../../app.module'
/**
 * 投稿タグ管理モーダルを開いた際の処理
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function EditPostTagModalInit(Restangular, $q) {
  /**
   * getPostById 投稿IDをキーに、投稿を取得
   * @param {fbPostId} 投稿ID
   * @return {Object} 投稿一覧
   */
  function getPostById(snsType: string, postId: number) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    const getUrl = `/post/getPostById?sns_type=${snsType}&post_id=${postId}`

    // 投稿を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data[0])
      })
    // promiseの結果を返す
    return deferred.promise
  }

  return {
    // 投稿内容取得
    getPostById: getPostById,
  }
}

function EditPostTagModalService(EditPostTagModalInit) {
  return {
    Init: EditPostTagModalInit,
  }
}

// 投稿タグ管理モーダル用のサービスを定義
app
  .factory('EditPostTagModalInit', EditPostTagModalInit)
  .factory('EditPostTagModalService', EditPostTagModalService)
